import { memo } from "react";
import { useEnvironment } from "../accessorPropagation/useEnvironment.js";
import { assertNever } from "../utils/assertNever.js";
function Component(render, decider, displayName) {
  const RenderWithEnv = (props) => render(props, useEnvironment());
  const renderWithEnv = typeof render !== "function" || render.length < 2 ? render : RenderWithEnv;
  if (decider === void 0 || typeof decider === "string") {
    render.displayName = decider;
    const augmentedRender2 = memo(renderWithEnv);
    augmentedRender2.staticRender = render;
    augmentedRender2.displayName = decider;
    return augmentedRender2;
  }
  render.displayName = displayName;
  const augmentedRender = memo(renderWithEnv);
  augmentedRender.displayName = displayName;
  if (typeof decider === "function") {
    augmentedRender.staticRender = decider;
    return augmentedRender;
  }
  if (typeof decider === "object") {
    for (const provisionName in decider) {
      const methodName = provisionName;
      augmentedRender[methodName] = decider[methodName];
    }
    return augmentedRender;
  }
  assertNever();
}
export {
  Component
};
//# sourceMappingURL=Component.js.map
